/**
 * Displays single power ranking
 */
import React from "react";

const Ranking = ({ img, number, team, w, l, d, g, gd, ppp, pk, desc }) => {
  return (
    // Container for all pages
    <div className="border-2 dark:border-0 border-light-3 py-2 flex flex-col items-center w-full justify-center dark:bg-dark-4 rounded mb-3">
      {/* header section */}
      <div className="md:px-20 flex flex-row items-center justify-between mb-2 w-full">
        <img
          src={`https://buiha.org.uk/assets/img/icon/60/${img}.png`}
          alt={team}
          className="sm:h-12 sm:w-12 h-10 w-10 ml-1 xs:ml-2"
        />
        <div className="flex flex-col items-center justify-center mx-2">
          <p className="leading-tight text-center text-xl mb-1 font-semibold">
            {number} - {team}
          </p>
          <p className="leading-tight text-center sm:text-md text-xxs">
            {w}W {l}L {d}D - {g}G {gd}GD - {ppp} PP% {pk} PK%
          </p>
        </div>
        <img
          src={`https://buiha.org.uk/assets/img/icon/60/${img}.png`}
          alt={team}
          className="sm:h-12 sm:w-12 h-10 w-10 mr-1 xs:mr-2"
        />
      </div>
      {/* text section */}
      <p className="md:px-24 text-center sm:text-md text-xs px-2 py-1">
        {desc}
      </p>
    </div>
  );
};

export default Ranking;
